import * as React from 'react';

import { numberToPrettyString } from '@cian/utils/lib/shared/number_helpers';
import classNames from 'classnames';

import { IJkMapData } from '../index';

import * as styles from './index.css';

export const JkPreview = (props: IJkMapData) => (
  <div className={styles['container']}>
    <a
      href={props.url}
      target="_blank"
      rel="noopener noreferrer"
      className={styles['image']}
      style={{ backgroundImage: `url(${props.imageUrl})` }}
    />
    <div className={styles['content']}>
      <div>
        <a
          href={props.url}
          target="_blank"
          rel="noopener noreferrer"
          className={classNames(styles['link'], 'iefix_color_main')}
        >
          {props.name}
        </a>
        <div className={styles['address']}>{props.address}</div>
        <div className={styles['status']}>{props.buildingStatusInfo}</div>
      </div>
      <div className={styles['price']}>{`от ${numberToPrettyString(props.minPrice)} \u20bd`}</div>
    </div>
  </div>
);
